import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet #outlet="outlet"></router-outlet>
        <app-module-loading *ngIf="!outlet.isActivated"></app-module-loading>
    `
})
export class AppComponent {
    constructor() { }
}
